import { DateRange } from '@angular/material/datepicker';
import { isNullOrUndefined } from '@sla-ng/core';
import * as moment from 'moment';

export function stringToMoment(date: moment.Moment | string): moment.Moment {
    if (moment.isMoment(date)) {
        return date;
    }
    return (isNullOrWhiteSpace(date)) ? undefined : moment.utc(date, 'YYYY-MM-DD');
}

export function isDatefilterValid(start: moment.Moment, end: moment.Moment): boolean {
    if (!isNullOrUndefined(start) && !isNullOrUndefined(end) && start.isAfter(end)) {
        return false;
    }
    /* Returns true if either both are undefined or both are set */
    return !((isNullOrUndefined(start) && !isNullOrUndefined(end)) || (isNullOrUndefined(end) && !isNullOrUndefined(start)));
}

export function isOverlapping(a: DateRange<moment.Moment>, b: DateRange<moment.Moment>): boolean {
    return (a.start.isSameOrBefore(b.end)) && (a.end.isSameOrAfter(b.start));
}

function isNullOrWhiteSpace(str: string): boolean {
    return str === null || str.trim() === '';
}
